import Layout from '../shared/Layout';
import PageHeader from '../shared/PageHeader';
import CronConfigPanel from './CronConfigPanel';
import WordBrowserPanel from './WordBrowserPanel';
import ApiUsageChart from '../../components/charts/ApiUsageChart';
import WordCronEffectivenessChart from '../../components/charts/WordCronEffectivenessChart';
import SettingsToolbar from '../../components/settings/SettingsToolbar';
import language from '../../variables/language';
import usePersistedState from '../../hooks/usePersistedState';
import '../../css/vocabulary-config.css';

export default function VocabularyConfig() {
  const t = language[language.lang].vocabularyConfigPage;
  const tEffectiveness = language[language.lang].wordCronEffectivenessChart;
  const [activeTab, setActiveTab] = usePersistedState('vocabulary-config-tab', 'dictionary');

  return (
    <Layout>
      <SettingsToolbar />
      <PageHeader name={t.title} />
      <main className="main-block">
        <div className="main-content txt-c">
          <div className="vocab-config-section">
            <div className="student-card-tabs">
              <div className={'student-card-tab' + (activeTab === 'dictionary' ? ' active' : '')} onClick={() => setActiveTab('dictionary')}>
                {t.browserSectionTitle}
              </div>
              <div className={'student-card-tab' + (activeTab === 'cron' ? ' active' : '')} onClick={() => setActiveTab('cron')}>
                {t.configSectionTitle}
              </div>
              <div className={'student-card-tab' + (activeTab === 'gemini' ? ' active' : '')} onClick={() => setActiveTab('gemini')}>
                {t.chartSectionTitle}
              </div>
              <div className={'student-card-tab' + (activeTab === 'effectiveness' ? ' active' : '')} onClick={() => setActiveTab('effectiveness')}>
                {t.effectivenessSectionTitle}
              </div>
            </div>
            {activeTab === 'dictionary' ? <WordBrowserPanel /> : ''}
            {activeTab === 'cron' ? <CronConfigPanel /> : ''}
            {activeTab === 'gemini' ? <ApiUsageChart contextPrefix="AiWordService." chartKey="vocabulary" /> : ''}
            {activeTab === 'effectiveness' ? (
              <div className="vocab-config-tab-body">
                <div className="vocab-config-subsection-title">{tEffectiveness.discoveryTitle}</div>
                <WordCronEffectivenessChart type="WORD_DISCOVERY" chartKey="discovery"
                  legendSuccess={tEffectiveness.legendSuccessDiscovery} legendFail={tEffectiveness.legendFailDiscovery} />
                <div className="vocab-config-subsection-title spaced">{tEffectiveness.classifyTitle}</div>
                <WordCronEffectivenessChart type="WORD_CLASSIFICATION" chartKey="classify"
                  legendSuccess={tEffectiveness.legendSuccessClassify} legendFail={tEffectiveness.legendFailClassify} />
              </div>
            ) : ''}
          </div>
        </div>
      </main>
    </Layout>
  );
}
